var EnvVarsServiceClass = /** @class */ (function () {
    function EnvVarsServiceClass() {
        this._vars = {};
    }
    Object.defineProperty(EnvVarsServiceClass, "instance", {
        get: function () {
            if (!this._instance)
                this._instance = new EnvVarsServiceClass();
            return this._instance;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EnvVarsServiceClass.prototype, "vars", {
        get: function () {
            return this._vars;
        },
        set: function (vars) {
            this._vars = vars;
        },
        enumerable: false,
        configurable: true
    });
    EnvVarsServiceClass.prototype.isBoolean = function (item) {
        return item === 'true' || item === 'false';
    };
    EnvVarsServiceClass.prototype.isUndefined = function (item) {
        return typeof item === 'undefined' || item === 'undefined';
    };
    EnvVarsServiceClass.prototype.isNull = function (item) {
        return (typeof item === 'object' && !item) || item === 'null';
    };
    EnvVarsServiceClass.prototype.isNumber = function (item) {
        return !isNaN(Number(item));
    };
    EnvVarsServiceClass.prototype.getVar = function (key, parse) {
        var envVar = this.vars[key];
        if (parse && envVar) {
            return this.parseVar(envVar, key);
        }
        return envVar;
    };
    EnvVarsServiceClass.prototype.parseVar = function (envVar, key) {
        var isBoolean = this.isBoolean(envVar);
        if (isBoolean)
            return envVar === 'true';
        var isUndefined = this.isUndefined(envVar);
        if (isUndefined)
            return undefined;
        var isNull = this.isNull(envVar);
        if (isNull)
            return null;
        var isNumber = this.isNumber(envVar);
        if (isNumber)
            return Number(envVar);
        try {
            return JSON.parse(envVar);
        }
        catch (error) {
            if (key) {
                console.warn("Failed to parse process.env.".concat(key));
            }
        }
        return envVar;
    };
    return EnvVarsServiceClass;
}());
var EnvVarsService = EnvVarsServiceClass.instance;

export { EnvVarsService };
//# sourceMappingURL=index.js.map
